import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../core/auth/auth.service';
import { BreadcrumbService } from '../core/breadcrumb.service';
import { initials } from '../core/util/text';
import { VettaMarkComponent } from '../shared/components/vetta-mark.component';

@Component({
  selector: 'vt-app-header',
  imports: [RouterLink, VettaMarkComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app-header.component.html',
  styleUrl: './app-header.component.scss',
})
export class AppHeaderComponent {
  protected readonly auth = inject(AuthService);
  protected readonly crumbs = inject(BreadcrumbService).crumbs;
  protected readonly initials = computed(() => initials(this.auth.user()?.name ?? '?'));
  protected readonly photoFailed = signal(false);
  protected readonly photo = computed(() => (this.photoFailed() ? null : (this.auth.user()?.picture ?? null)));
}
